// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1f0cI","label":"SetPasswdForm_label__13Dwy"};